import FastClick from "fastclick";
import svg4everybody from "svg4everybody";

import * as serviceWorker from "./helpers/serviceWorker";

import ready from "@/modules/_utils/dom/ready";

import LazyLoad from "@/modules/lazy/lazyload";
import CartStepComplete from "@/modules/cart-step-6/cart-step-complete";
import Browsehappy from "@/modules/browsehappy/browsehappy";
import LoginApp from "@/modules/login-content/login";
import CartApp from "@/modules/cart-step-3/cart-step";
import AccountModal from "@/modules/account/account-modal";
import PaymentTab from "@/modules/cart-step-5/payment-tab";
import ScrollTop from "@/modules/scroll-top/scroll-top";
import NetworkStatus from "@/modules/network-status/network-status";
import Slider from "@/modules/slider/slider";
import ProductSlider from "@/modules/product-slider/product-slider";
import BlogSlider from "@/modules/blog/blog-slider";
import NewsSlider from "@/modules/news-content/news-slider";
import GallerySlider from "@/modules/gallery-slider/gallery-slider";
import ModalScreen from "@/modules/modal/modal";
import Header from "@/modules/header/header";

// Factories class based plugins
Browsehappy(".browsehappy");
ScrollTop(".scroll-top");
NetworkStatus();
LazyLoad();

// Simple functional plugins

ready(function() {
  FastClick.attach(document.body);
  CartStepComplete();
  Header();
  ModalScreen();
  AccountModal();
  LoginApp();
  CartApp();
  PaymentTab();
  GallerySlider();
  ProductSlider(".swiper-container-product");
  BlogSlider(".swiper-container-blog");
  NewsSlider(".swiper-container-news");
  Slider(".swiper-container");
  svg4everybody();
});

// If you want your app to work offline and load faster, you can change
// `unregister()` to `register()` below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();

module.exports = {
  ScrollTop
};
